import { Routes } from '@angular/router';

export const IAC_APP_ROUTES: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./iac-app/iac-app.routes').then((m) => m.IacAppRoutes),
  },
  {
    path: 'styleguide',
    title: 'Styleguide',
    loadChildren: () => import('./styleguide/styleguide.routing').then((m) => m.StyleguideRoutes),
  },
];
